// speech store — balaozinhos de fala em cima da cabeca dos players.
// Usado pra UX de truco/aceito/correu sem modal cobrindo a mesa
// (request Leonardo 2026-05-18: "aparece um balaozin na cabeca").
//
// Cada player tem 1 balao ativo no maximo; novo balao substitui o
// anterior. Auto-expira apos ~2s pra nao poluir a tela.

import { writable } from 'svelte/store';

export type Speech = {
  text: string;
  // 'shout' = pedido (TRUCO!/SEIS!/...), gradiente roxo
  // 'ack'   = resposta positiva (ACEITO!), gradiente verde
  // 'run'   = correu (CORRO!/FUJO!), gradiente vermelho
  tone: 'shout' | 'ack' | 'run';
  key: number; // bump pra forcar re-animacao quando troca rapido
  sticky?: boolean; // se true, nao expira sozinho — precisa clearPlayer()
};

// Map<playerId, Speech>. Svelte 5 reage por replace-Map.
export const playerSpeech = writable<Map<string, Speech>>(new Map());

const DURATION_MS = 2000;
const timers = new Map<string, number>();
let counter = 0;

export function speak(
  playerId: string,
  text: string,
  tone: Speech['tone'],
  opts: { sticky?: boolean } = {},
) {
  if (!playerId) return;
  counter++;
  const entry: Speech = { text, tone, key: counter, sticky: opts.sticky };
  playerSpeech.update((m) => {
    const next = new Map(m);
    next.set(playerId, entry);
    return next;
  });
  // Limpa timer anterior (caso troque o balao antes do timeout).
  const prevTimer = timers.get(playerId);
  if (prevTimer) {
    clearTimeout(prevTimer);
    timers.delete(playerId);
  }
  // Sticky nao agenda expiracao — fica ate clearPlayer() ou clearSpeech().
  if (opts.sticky) return;

  const t = window.setTimeout(() => {
    playerSpeech.update((m) => {
      // So remove se ainda for o mesmo balao (caso outro chegou no
      // meio, deixa o novo viver seus 2s completos).
      const current = m.get(playerId);
      if (!current || current.key !== entry.key) return m;
      const next = new Map(m);
      next.delete(playerId);
      return next;
    });
    timers.delete(playerId);
  }, DURATION_MS);
  timers.set(playerId, t);
}

// Remove imediatamente o balao de um player especifico. Usado quando
// o pedido de truco resolveu (aceito/correu) pra apagar o balao
// sticky do desafiante.
export function clearPlayer(playerId: string) {
  if (!playerId) return;
  const t = timers.get(playerId);
  if (t) {
    clearTimeout(t);
    timers.delete(playerId);
  }
  playerSpeech.update((m) => {
    if (!m.has(playerId)) return m;
    const next = new Map(m);
    next.delete(playerId);
    return next;
  });
}

export function clearSpeech() {
  playerSpeech.set(new Map());
  for (const t of timers.values()) clearTimeout(t);
  timers.clear();
}
